import { Box } from "@/components/layout/flexbox";
import { MeetingBasics } from "@/components/pieces/coaching/meetings/MeetingBasics";
import { RateMeeting } from "@/components/pieces/coaching/meetings/MeetingList";
import { PanelComponent, ParticipantComponent } from "@/types/programs";
import { NonNullableArrayItem } from "@/utils/types";

type Meeting = NonNullableArrayItem<ParticipantComponent["meetings"]>;

interface OneOneIntroSessionProps {
  meeting: Meeting;
  component?: PanelComponent;
}

export function OneOneSession({ meeting }: OneOneIntroSessionProps) {
  const { chatChannelId, customerId } = meeting || {};

  return (
    <Box className="round-corners xs:p-5 xs:gap-3.5 flex flex-col border-1 border-neutral-300 hover:bg-blue-50 md:gap-4 md:p-6">
      <MeetingBasics
        meeting={meeting}
        chatChannelId={chatChannelId}
        large={false}
        showMessageButton={true}
        customerId={String(customerId)}
      />
      {meeting.canLeaveRating ? (
        <>
          <hr className="m-0 border-neutral-300" />
          <RateMeeting meeting={meeting} />
        </>
      ) : null}
    </Box>
  );
}
